import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconRequest } from '@sorare/core/src/atoms/icons/system/iconRequest.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { Trapezoid } from '@sorare/core/src/atoms/ui/Trapezoid';

const Root = styled(Trapezoid)`
  background: var(--c-set-static-surface-primary);
`;

export const InviteTitle = () => {
  return (
    <Root>
      <BrandM color="var(--c-black)">
        <Horizontal gap={0.5} center>
          <FontAwesomeIcon icon={iconRequest} />
          <FormattedMessage defaultMessage="Invite your friends" />
        </Horizontal>
      </BrandM>
    </Root>
  );
};
